import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const GlamgirlLine = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d="M14.658,46.114a24.013,24.013,0,0,1,0-44.228A24,24,0,0,1,40.971,40.971a24.029,24.029,0,0,1-26.312,5.144ZM3.6,24A20.4,20.4,0,1,0,24,3.6,20.423,20.423,0,0,0,3.6,24ZM24.78,41.921C23.3,41.458,22.9,39.952,22.9,38.545c0-3.844,1.67-8.022,3.565-11.3A37.8,37.8,0,0,1,28.559,24c-.763-2.661-1.69-5.277-2.636-7.887a16.737,16.737,0,0,1-2.082,8.013,4.965,4.965,0,0,1-3.092,2.323c-2.038.481-3.27-1.049-4.112-2.718a12.5,12.5,0,0,1-.908-9.464A19.28,19.28,0,0,1,17.8,9.683,17.58,17.58,0,0,1,19.153,7.77a11.124,11.124,0,0,1,.823-.932c.147-.144.9-.81.15-.136,1.418-1.273,4.546.192,3,1.973a17,17,0,0,0-4.243,12.509c.075,1.176.064,2.923,1.553,3.369,1.732.516,2.884-1.71,3.449-2.964a19.844,19.844,0,0,0,1.553-6.881.212.212,0,0,1,.273-.215c.272-.229.737-.275.9.091a67.588,67.588,0,0,1,2.965,8.091,23.471,23.471,0,0,1,3.478-3.507c.77-.657.888.3.247.833a41.976,41.976,0,0,0-3.443,3.662c.506,1.831.931,3.682,1.261,5.544.663,3.747,1.32,8.458-1.772,11.35a5.4,5.4,0,0,1-3.518,1.522A3.489,3.489,0,0,1,24.78,41.921Zm2.3-14.058a30.025,30.025,0,0,0-2.226,5.755c-.442,1.63-1.594,5.193-.328,6.715.907,1.092,2.728.4,3.625-.354a6.711,6.711,0,0,0,2.138-4.333,22.449,22.449,0,0,0-.492-6.408c-.256-1.435-.583-2.85-.959-4.25A21.722,21.722,0,0,0,27.076,27.863Z" fill={fill}/>
    </svg>
  );
};

GlamgirlLine.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

GlamgirlLine.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};